import { TPollTime } from '@src/types';

export const MAX_NUM_OF_OPTIONS = 10;

export const TIME_OPTIONS: { label: string; value: TPollTime }[] = [
  { label: '5 min', value: '5' },
  { label: '10 min', value: '10' },
  { label: '15 min', value: '15' },
  { label: 'Never', value: 'none' },
];
